<template>
  <div class="tables">
    <div>
      <h6>姓名</h6>
      <p><span>使用目的</span> <span>用于进行实名认证</span></p>
      <p><span>使用场景</span> <span>用户注册实名认证时</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.name!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.name}}</span>
      </p>
    </div>
    <div>
      <h6>身份证号</h6>
      <p><span>使用目的</span> <span>用于进行实名认证</span></p>
      <p><span>使用场景</span> <span>用户注册实名认证时</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.idcard!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.idcard}}</span>
      </p>
    </div>
    <div>
      <h6>公司名称</h6>
      <p><span>使用目的</span> <span>用于进行实名认证</span></p>
      <p><span>使用场景</span> <span>用户注册实名认证时</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.companyName!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.companyName}}</span>
      </p>
    </div>
    <div>
      <h6>营业执照</h6>
      <p><span>使用目的</span> <span>用于进行实名认证</span></p>
      <p><span>使用场景</span> <span>用户注册实名认证时</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.bussinessLicense!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.bussinessLicense}}</span>
      </p>
    </div>
    <div>
      <h6>银行卡号</h6>
      <p><span>使用目的</span> <span>用于完成提现功能</span></p>
      <p><span>使用场景</span> <span>用户提现过程中</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.bankCard!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p @click="goBankCard">
        <span>信息内容</span> <span>{{ user.bankCard}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { getSellerInfo } from "@/api/seller";
export default {
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    console.log(this.$route.params);
    this._getUserInfo()
  },
  methods: {
    async _getUserInfo(){
        const res = await getSellerInfo({});
        if(res.appStatus.errorCode == 0){
            this.user = {...res.content}
        }
    },
    
    goBankCard(){
        if(this.user.bankCard!== '-'){
            this.$router.push({path:'e_bankCard'})
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.tables {
  margin: 10px;
  padding-bottom: 30px;
  > div {
    margin-top: 20px;
    background: #d9d9d9;
    h6 {
      background: #fff;
    }
    p {
      font-size: 14px;
      display: flex;
      line-height: 30px;
      span:first-child {
        background: #d9d9d9;
        width: 100px;
        text-align: center;
      }
      span:last-child {
        width: 100%;
        display: block;
        background: #fff;
        border: 1px solid #d9d9d9;
        text-align: center;
      }
    }
  }
}
</style>
